import 'waypoints/lib/jquery.waypoints.min.js';

export default {
  init() {
    // JavaScript to be fired on all pages

    /** GLOBAL VARIABLES */
    var body = document.querySelector('body'),
        mobileNav       = document.querySelector('#mobile-nav'),
        mobileNavButton = document.querySelector('#mobile-nav-icon');
    /** END GLOBAL VARIABLES */

    var waypoints = $('.initiative__images').waypoint({ // eslint-disable-line no-unused-vars
        handler: function(){
            $('.initiative__images').toggleClass('is-fixed');
        },
        offset: 100,
    });

    function itemReveal() {
        var itemQueue = [];
        var delay = 100;
        var queueTimer;

        function processItemQueue() {
            // console.log(itemQueue[0]);
            if (queueTimer) return // We're already processing the queue
            queueTimer = window.setInterval(function () {
                if (itemQueue.length) {
                    $(itemQueue.shift()).addClass('revealed');
                    processItemQueue()
                } else {
                    window.clearInterval(queueTimer)
                    queueTimer = null
                }
            }, delay)
        }

        $(".reveal").waypoint(function () {
            itemQueue.push(this.element)
            processItemQueue();
        }, {
            offset: '85%',
        });
    }

    itemReveal();

    /** SKIP LINK NAVIGATION */
    $('#skip-to-content').click(function () {
      // strip the leading hash and declare
      // the content we're skipping to
      var skipTo = "#" + this.href.split('#')[1];
      // Setting 'tabindex' to -1 takes an element out of normal 
      // tab flow but allows it to be focused via javascript
      $(skipTo).attr('tabindex', -1).on('blur focusout', function () {
        // when focus leaves this element, 
        // remove the tabindex attribute
        $(this).removeAttr('tabindex');
      }).focus(); // focus on the content container
    });
    /** END SKIP LINK NAVIGATION */

    /** RESPONSIVE NAV OPEN/CLOSE **/
    // Toggle menu icon
    if (mobileNavButton) {
        mobileNavButton.addEventListener('click', function () {
          body.classList.toggle('mobile-nav-open');
        });
      }
  
      // Close menu if page is clicked (not menu item)
      if (mobileNav) {
        mobileNav.addEventListener('click', function (e) {
          // Don't hide if click is on a child element (nav link)
          if (e.target !== this) {
            return;
          }
          mobileNavButton.classList.toggle('opened');
          $("#nav-toggle").prop('checked', false);
          body.classList.toggle('mobile-nav-open');
        });
      }
      /** END RESPONSIVE NAV OPEN/CLOSE **/
    
    /** MASTHEAD PRGRESSIVE IMAGES **/
    var masthead = document.querySelector('.masthead'),
    placeholderOverlay = document.querySelector('.masthead__overlay');

    if (masthead && placeholderOverlay) {
        // Load full size image. When loaded, fade our placeholder add it as bg to masthead
        var img = new Image();
        img.src = masthead.dataset.imageSrc;
        img.onload = function () {
            placeholderOverlay.classList.add('fade-out');
            masthead.style.backgroundImage = "url(" + img.src + ")";
        };
    }
    /** END MASTHEAD PRGRESSIVE IMAGES **/

    /* HEADER SCROLL EFFECT */
    // Reference: http://tympanus.net/codrops/2013/06/06/on-scroll-animated-header/
    var animatedHeader = (function () { // eslint-disable-line no-unused-vars
        var didScroll    = false,
            scrollOffset = 0;
  
        function scrollY() {
            return window.pageYOffset || document.documentElement.scrollTop;
        }
  
        function scrollPage() {
            var sy = scrollY();
            if (sy > scrollOffset) {
                body.classList.add('scroll-triggered');
            }
            else {
                body.classList.remove('scroll-triggered');
            }
            didScroll = false;
        }
  
        function init() {
            window.addEventListener('load', scrollPage);
            window.addEventListener('scroll', function (event) { // eslint-disable-line no-unused-vars
            //    console.log(scrollY);
  
                if (!didScroll) {
                    didScroll = true;
                    setTimeout(scrollPage, 50);
                }
            }, false);
        }
        init();
    })();
      /* END HEADER SCROLL EFFECT */

    /** ANIMATED ANCHOR LINKS **/
    $('a[href*="#"]:not([href="#"])').click(function (e) {
        // Doesn't do it on page builder tabs
        if (!$(this).closest('li').hasClass('vc_tta-tab')) {
            if (!$(this).closest('h4').hasClass('vc_tta-panel-title')) {
                if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                    var target = $(this.hash);
                    var $this = this;
                    var header = $('header.header');
                    var wpAdminBar = $('#wpadminbar');
                    var fixedHeaderOffset = parseInt(header.outerHeight()) - parseInt(header.css("padding-top").replace("px", ""));
                    // If we're logged in and WP ADmin Bar exists, add it to the offset
                    if ( wpAdminBar.length ) {
                        fixedHeaderOffset += parseInt(wpAdminBar.outerHeight());
                    }
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    if (target.length) {
                        $('html,body').animate({
                            scrollTop: (target.offset().top - fixedHeaderOffset),
                        }, 500, function () {
                            if (history.pushState) {
                                history.pushState(null, null, $this.hash);
                            }
                            else {
                                location.hash = $this.hash;
                            }
                        });
                        e.preventDefault();
                    }
                }
            }    
        }    
    });
    /** END ANIMATED ANCHOR LINKS **/

    /** Break link text to new line when link text is a URL **/
    $(document).ready(function(){
        $('a').each(function() {
            var $this = $(this);
            var innerLink = $this.text();
            if (innerLink.startsWith('http')) {
                $this.css('word-break','break-all');
            }
        });
    });

    /** End Break link text to new line when link text is a URL **/

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js